"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _status = require("@/api/iot/status");
var _merchant = require("@/api/merchant");
var _setmeal = require("@/api/iot/setmeal");
var _branch = require("@/api/iot/branch");
var _deviceType = require("@/api/iot/deviceType");
var _device = require("@/api/iot/device");
var _default = {
  props: ['editItem', 'deviceTypeList'],
  data: function data() {
    return {
      dialogVisible: false,
      btnLoading: false,
      form: {
        id: '',
        member_id: '',
        merchant_id: '',
        branch_id: '',
        terminal_no: '',
        name: '',
        kwh_price: 0,
        status: 1,
        is_online: 1,
        warehouse_num: 0,
        device_type_id: 1,
        mqtt_tag: 'default'
        // battery: '',
        // address: '',
        // longitude: '',
        // latitude: '',
      },

      rules: {
        merchant_id: [{
          required: true,
          message: '请选择商户名称',
          trigger: 'change'
        }],
        branch_id: [{
          required: true,
          message: '请选择所在网点',
          trigger: 'change'
        }],
        terminal_no: [{
          required: true,
          message: '请输入换电柜编号',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入换电柜名称',
          trigger: 'change'
        }],
        kwh_price: [{
          required: true,
          message: '请输入电价',
          trigger: 'change'
        }, {
          type: 'number',
          min: 0,
          message: '电价不能为负数',
          trigger: 'change'
        }],
        warehouse_num: [{
          required: true,
          message: '请输入电池仓位数',
          trigger: 'change'
        }, {
          type: 'number',
          min: 1,
          message: '电池仓位数必须大于0',
          trigger: 'change'
        }]
      },
      merchantList: [],
      deviceList: [],
      setmealList: [],
      branchList: [],
      deviceStatusList: [],
      onlineStatusList: [],
      mqttTagList: []
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return (this.editItem ? '修改' : '添加') + '换电柜';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            // 编辑
            for (var key in _this.form) {
              _this.form[key] = _this.editItem[key];
            }
          }
        });
      } else {
        this.reset();
      }
    }
  },
  mounted: function mounted() {
    this.getMerchantList();
    this.getDeviceStatusList();
    this.getOnlieStatusList();
    this.getMqttTagList();
    // this.getSetmealList()
    this.getBranchlList();
  },
  methods: {
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getDeviceStatusList: function getDeviceStatusList() {
      var _this2 = this;
      (0, _status.getDeviceStatusList)().then(function (res) {
        // console.log('getDeviceStatusList', res)
        if (res) {
          _this2.deviceStatusList = res || [];
        }
      });
    },
    getOnlieStatusList: function getOnlieStatusList() {
      var _this3 = this;
      (0, _status.getOnlieStatusList)().then(function (res) {
        // console.log('getOnlieStatusList', res)
        if (res) {
          _this3.onlineStatusList = res || [];
        }
      });
    },
    getMqttTagList: function getMqttTagList() {
      var _this4 = this;
      (0, _device.getMqttTagList)().then(function (res) {
        // console.log('getOnlieStatusList', res)
        if (res) {
          _this4.mqttTagList = res || [];
        }
      });
    },
    getSetmealList: function getSetmealList() {
      var _this5 = this;
      (0, _setmeal.setmealGetList)().then(function (res) {
        _this5.setmealList = res;
      });
    },
    getBranchlList: function getBranchlList() {
      var _this6 = this;
      (0, _branch.branchGetList)().then(function (res) {
        _this6.branchList = res;
      });
    },
    reset: function reset() {
      this.form = this.$options.data().form;
      this.$refs['form'].resetFields();
    },
    submit: function submit() {
      var _this7 = this;
      this.$refs['form'].validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(valid) {
          var res;
          return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 9;
                    break;
                  }
                  _this7.btnLoading = true;
                  _context2.next = 4;
                  return (0, _device.cabinetSave)(_this7.form).catch(function () {});
                case 4:
                  res = _context2.sent;
                  _this7.btnLoading = false;
                  if (res) {
                    _this7.dialogVisible = false;
                    _this7.$emit('getList');
                  }
                  _context2.next = 11;
                  break;
                case 9:
                  _this7.$message({
                    message: '请检查表单错误',
                    type: 'error'
                  });
                  return _context2.abrupt("return", false);
                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};
exports.default = _default;